import decrypt from "../../utils/helpers/decrypt"
import encrypt from "../../utils/helpers/encrypt"

const StorageService = {
   
    setToStorage: (values: Object) => {
        /** Get keys from 'values' Object */
        const entries = Object.entries(values)
        
        entries.forEach(value => {
            /** value[0] is key 
             *  value[1] is value of the key
             */
            localStorage.setItem(value[0],encrypt(value[1]))
            
        })
    },

    getFromStorage: (queryValues: Array<string>) => {
        /** 'queryValues' is an array of strings
         * strings will be name of the keys
        */
        let retreived: any = {}
        queryValues.forEach(key => {
            if (localStorage?.getItem(key) !== null) {
                let value = decrypt(localStorage?.getItem(key))
                retreived = { ...retreived, [key]: value };
            }
            
        })

        return {...retreived}
    }
}

export default StorageService